export const categories = [
  {
    id: 1,
    name: "Schuhe",
    englishName: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Pair%20of%20premium%20white%20leather%20sneakers%20placed%20on%20a%20textured%20concrete%20surface%20with%20dried%20eucalyptus%20branches%20nearby%2C%20morning%20sunlight%20casting%20long%20diagonal%20shadows%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20minimal%20composition%20with%20negative%20space%20and%20organic%20elements&width=600&height=800&seq=cat-v2-shoes-a7&orientation=portrait"
  },
  {
    id: 2,
    name: "Hoodies & Pullover",
    englishName: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Thick%20knit%20oatmeal-colored%20hoodie%20casually%20draped%20over%20a%20vintage%20wooden%20chair%20back%2C%20afternoon%20light%20filtering%20through%20sheer%20linen%20curtains%2C%20soft%20boho%20aesthetic%2C%20texture-rich%20fabric%20details%20visible%2C%20warm%20cream%20and%20sand%20tones%2C%20lifestyle%20fashion%20photography&width=600&height=800&seq=cat-v2-hoodies-b8&orientation=portrait"
  },
  {
    id: 3,
    name: "T-Shirts",
    englishName: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Heavyweight%20organic%20cotton%20t-shirt%20in%20sage%20green%20flat%20lay%20on%20raw%20linen%20fabric%20with%20a%20delicate%20ceramic%20vase%20and%20dried%20wildflowers%20beside%20it%2C%20soft%20diffused%20window%20light%2C%20earthy%20muted%20color%20palette%2C%20artisanal%20lifestyle%20product%20photography&width=600&height=800&seq=cat-v2-tshirts-c9&orientation=portrait"
  },
  {
    id: 4,
    name: "Jacken",
    englishName: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Vintage%20brown%20leather%20jacket%20hanging%20on%20exposed%20brick%20wall%20with%20warm%20copper%20pendant%20light%20glowing%20nearby%2C%20industrial%20loft%20atmosphere%2C%20rich%20textured%20leather%20grain%20visible%2C%20moody%20yet%20warm%20editorial%20photography%2C%20terracotta%20and%20rust%20undertones&width=600&height=800&seq=cat-v2-jackets-d1&orientation=portrait"
  },
  {
    id: 5,
    name: "Hosen & Shorts",
    englishName: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Wide-leg%20cream%20linen%20trousers%20elegantly%20suspended%20from%20a%20minimalist%20brass%20clothing%20rail%2C%20soft%20studio%20lighting%20from%20above%2C%20clean%20architectural%20composition%2C%20premium%20fabric%20texture%20and%20drape%20visible%2C%20serene%20neutral%20palette%20with%20subtle%20metallic%20accent&width=600&height=800&seq=cat-v2-pants-e2&orientation=portrait"
  },
  {
    id: 6,
    name: "Kopfbedeckung",
    englishName: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-smile-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Handcrafted%20wool%20felt%20fedora%20hat%20resting%20on%20a%20stack%20of%20vintage%20leather-bound%20books%20on%20a%20dark%20walnut%20desk%2C%20soft%20golden%20hour%20light%20streaming%20through%20window%20blinds%2C%20classic%20gentleman%20aesthetic%2C%20warm%20amber%20and%20cognac%20tones%2C%20refined%20still%20life%20photography&width=600&height=800&seq=cat-v2-headwear-f3&orientation=portrait"
  },
  {
    id: 7,
    name: "Sets",
    englishName: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Matching%20terry%20cloth%20lounge%20set%20in%20dusty%20rose%20folded%20neatly%20inside%20a%20woven%20rattan%20basket%2C%20surrounded%20by%20dried%20pampas%20grass%20in%20a%20ceramic%20vase%2C%20soft%20morning%20light%2C%20cozy%20aesthetic%2C%20warm%20blush%20and%20beige%20tones%2C%20lifestyle%20home%20photography&width=600&height=800&seq=cat-v2-sets-g4&orientation=portrait"
  },
  {
    id: 8,
    name: "Unterwäsche",
    englishName: "Underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20bamboo%20fiber%20underwear%20set%20arranged%20on%20smooth%20river%20stones%20with%20delicate%20white%20flowers%20and%20morning%20dew%2C%20zen%20spa%20atmosphere%2C%20natural%20light%20reflecting%20off%20water%20nearby%2C%20pure%20and%20fresh%20aesthetic%2C%20light%20sage%20and%20ivory%20palette%2C%20clean%20wellness%20photography&width=600&height=800&seq=cat-v2-underwear-h5&orientation=portrait"
  },
  {
    id: 9,
    name: "Trikots",
    englishName: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-medal-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20football%20jersey%20in%20deep%20navy%20with%20subtle%20metallic%20stitching%20displayed%20on%20a%20dark%20textured%20background%2C%20dramatic%20spotlight%20from%20above%20creating%20theatrical%20shadows%2C%20stadium%20atmosphere%2C%20athletic%20prestige%20photography%2C%20rich%20navy%20and%20silver%20tones&width=600&height=800&seq=cat-v2-jersey-i6&orientation=portrait"
  },
  {
    id: 10,
    name: "Accessoires",
    englishName: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-vip-crown-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20minimalist%20jewelry%20including%20a%20thin%20gold%20chain%20necklace%2C%20signet%20ring%2C%20and%20leather%20bracelet%20artfully%20scattered%20on%20raw%20silk%20fabric%2C%20afternoon%20sunlight%20creating%20prismatic%20reflections%2C%20luxury%20editorial%20still%20life%2C%20warm%20golden%20and%20ivory%20palette&width=600&height=800&seq=cat-v2-accessories-j7&orientation=portrait"
  },
  {
    id: 11,
    name: "Taschen",
    englishName: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-shopping-bag-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Structured%20canvas%20tote%20bag%20in%20olive%20green%20leaning%20against%20a%20weathered%20terracotta%20planter%20with%20trailing%20ivy%2C%20Mediterranean%20courtyard%20setting%2C%20dappled%20sunlight%20through%20olive%20tree%20leaves%2C%20rustic%20luxury%20aesthetic%2C%20warm%20earth%20tones%20with%20verdant%20accents%2C%20travel%20lifestyle%20photography&width=600&height=800&seq=cat-v2-bags-k8&orientation=portrait"
  },
  {
    id: 12,
    name: "Gürtel",
    englishName: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    imageUrl: "https://readdy.ai/api/search-image?query=Hand-tooled%20cognac%20leather%20belt%20with%20brass%20buckle%20elegantly%20spiraled%20on%20a%20slab%20of%20polished%20black%20marble%2C%20dramatic%20side%20lighting%20emphasizing%20the%20leather%20grain%20and%20metallic%20sheen%2C%20luxury%20accessory%20photography%2C%20rich%20cognac%20and%20charcoal%20contrast&width=600&height=800&seq=cat-v2-belts-l9&orientation=portrait"
  },
  {
    id: 13,
    name: "Parfums",
    englishName: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Artisanal%20amber%20glass%20perfume%20bottle%20surrounded%20by%20scattered%20dried%20rose%20petals%20and%20cinnamon%20sticks%20on%20a%20dark%20slate%20surface%2C%20candlelight%20flickering%20nearby%20creating%20warm%20romantic%20ambiance%2C%20luxury%20fragrance%20photography%2C%20deep%20amber%20and%20burgundy%20tones%20with%20golden%20highlights&width=600&height=800&seq=cat-v2-perfumes-m1&orientation=portrait"
  },
  {
    id: 14,
    name: "Sonstiges",
    englishName: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Eclectic%20flat%20lay%20of%20lifestyle%20objects%20including%20sunglasses%2C%20notebook%2C%20fountain%20pen%2C%20pocket%20watch%2C%20and%20a%20ceramic%20coffee%20cup%20on%20textured%20kraft%20paper%2C%20overhead%20shot%2C%20natural%20window%20light%2C%20creative%20studio%20aesthetic%2C%20warm%20sepia%20and%20cream%20palette%2C%20curated%20workspace%20photography&width=600&height=800&seq=cat-v2-other-n2&orientation=portrait"
  }
];